var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DailyCheckPage',{attrs:{"page":this.page,"title":this.title,"menuNameUpper":_vm.menuNameUpper,"menuNameLower":_vm.menuNameLower}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }